import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import AutoTooltipIcon from "components/Shared/AutoTooltipIcon";
import ReceivedEmailCategoryTag from "components/Shared/ReceivedEmailCategoryTag";
import EditableAssociationAction from "components/Shared/SelectedEmail/Actions/EditableAssociationAction";
import CategoryChangeDialogContent from "./ChangeDialogContent";

const fragment = gql(/* GraphQL */ `
  fragment SelectedEmailCategoryAction on ReceivedEmailMessage {
    emailMessageId
    receivedEmailMessageCategory {
      receivedEmailMessageId
      category
      isAutoAssociated
    }
  }
`);

type Props = {
  data: FragmentType<typeof fragment> | null | undefined;
  isAdmin?: boolean;
};

export default function SelectedEmailCategoryAction({ data, isAdmin }: Props) {
  const rem = getFragmentData(fragment, data);
  const association = rem?.receivedEmailMessageCategory;
  const category = association?.category;

  return (
    <EditableAssociationAction
      label="Category"
      isAssociated={Boolean(category)}
      associatedValue={
        category && <ReceivedEmailCategoryTag category={category} />
      }
      editActionLabel="Change category association"
      associatedContent={
        association?.isAutoAssociated ? (
          <AutoTooltipIcon label="Category automatically associated using email address" />
        ) : undefined
      }
      emptyLabel="Uncategorized"
      assignButtonLabel="Assign Category"
      renderEditDialog={({ cancelRef, onClose }) => (
        <CategoryChangeDialogContent
          cancelRef={cancelRef}
          currentCategory={category ?? null}
          emailId={rem?.emailMessageId}
          hasAssociation={Boolean(association)}
          isAdmin={isAdmin}
          onClose={onClose}
        />
      )}
    />
  );
}
